import { SvgLupa } from "../../../../icons";
import { Input } from "../../../ui";
import { SearchInputProps } from "@/types";

/**
 * 🟢 Componente SearchInput
 * Campo de búsqueda reutilizable con icono de lupa.
 * Oculta la lupa en móvil cuando el panel de resultados está abierto.
 */
const SearchInput: React.FC<SearchInputProps & { mobileMode?: boolean; panelOpen?: boolean }> = ({
  value,
  onChange,
  className = "",
  onFocus,
  onBlur,
  showIcon = true,
  mobileMode = false,
  panelOpen = false,
}) => {
  // 🔹 La lupa se muestra solo si:
  // - showIcon es true
  // - NO estamos en móvil con panel abierto
  const showLupa = showIcon && !(mobileMode && panelOpen);

  return (
    <div className={`flex items-center ${className}`}>
      <div className="relative w-full">
        <Input
          type="text"
          placeholder="Buscar..."
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          className="w-full px-3 pr-9 text-sm border border-black rounded-md bg-white text-black placeholder-zinc-800 focus:border-l-blue-500 focus:border-t-blue-500 focus:shadow-md focus:shadow-blue-500 "
        />

        {/* 🔍 Lupa visible solo si showLupa = true */}
        {showLupa && (
          <div className="absolute right-2 top-1/2 transform -translate-y-1/2 text-zinc-700 pointer-events-none transition-all duration-300">
            <SvgLupa className="w-6 h-6 md:w-6 md:h-6" />
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchInput;
